import React from "react";

const Bash_Rsync = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Rsync</h2>
      <p>Efficiently sync files and directories (local or remote).</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>rsync [options] source dest</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>rsync -avz src/ user@host:/dest/
rsync -av --delete src/ dest/</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use --dry-run to preview changes.</p>
    </div>
  );
};

export default Bash_Rsync;
